import { render } from "./produto-editar.vue?vue&type=template&id=ef7e2a46&scoped=true"
import script from "./produto-editar.vue?vue&type=script&lang=js"
export * from "./produto-editar.vue?vue&type=script&lang=js"

import "./produto-editar.vue?vue&type=style&index=0&id=ef7e2a46&scoped=true&lang=css"

import exportComponent from "C:\\Users\\iuril\\Documents\\econopro\\mainapp\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef7e2a46"]])

export default __exports__